import { jsxs, jsx } from 'react/jsx-runtime';
import { isValidElement } from 'react';
import styled from 'styled-components';
import { CheckmarkIcon } from '@minuthq/meatball-ui-icons';
import { Text } from '../text/text.js';
import { colors, colorScale } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function Checkbox({ label, checked, onCheck, error, disabled, required, textProps, inputProps, className, fullWidth, }) {
    return (jsxs(StyledLabel, { className: className, "$fullWidth": fullWidth, children: [jsx(StyledCheckbox, { "$error": !!error, children: jsx(CheckmarkIcon, {}) }), jsx(VisuallyHiddenInput, { type: "checkbox", checked: checked, onChange: (e) => {
                    onCheck?.(e.target.checked, e);
                }, disabled: disabled, required: required, ...inputProps }), isValidElement(label) ? (label) : (jsx(Text, { color: "unset", variant: "bodyS", ...textProps, children: label }))] }));
}
const StyledLabel = styled.label `
  position: relative;
  display: ${({ $fullWidth }) => ($fullWidth ? "flex" : "inline-flex")};
  align-items: center;
  gap: ${spacing.S};
  cursor: pointer;

  &:has(input:disabled) {
    cursor: auto;
    color: ${colors.neutralDark2};
  }
`;
const StyledCheckbox = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: transparent;
  border: 2px solid
    ${({ $error }) => ($error ? colors.systemError : colors.neutralDark3)};
  border-radius: 4px;
  transition: background-color 50ms;

  &:hover:not(:has(+ input:disabled), :has(+ input:checked)) {
    background-color: ${colors.primaryLight};
  }

  &:has(+ input:checked:not(:disabled)) {
    background-color: ${colors.primary};
    border-color: ${colors.primary};

    svg {
      opacity: 1;
    }
  }

  &:has(+ input:disabled) {
    border-color: ${colors.neutralDark2};
  }

  &:has(+ input:disabled:checked) {
    border-color: ${colors.neutralDark2};
    background-color: ${colors.neutralDark2};

    svg {
      opacity: 1;
    }
  }

  &:has(+ input:focus-visible) {
    outline: 2px solid ${colorScale.blue[700]};
    outline-offset: 1px;
  }

  svg {
    opacity: 0;
    width: 14px;
    color: ${colors.neutralLight};
  }
`;
const VisuallyHiddenInput = styled.input `
  position: absolute;
  height: 0;
  width: 0;
  opacity: 0;
`;

export { Checkbox };
